export default {
  name: 'contractorVisitorSignOut',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest(`/sites/visitors/contractor/${data.id}`, 'POST', data)
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data;
    ctx.router.push({ name: `sites-siteid-view-visitors`, params: { siteid: data.siteid } })
  }
}
